import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { Table, TableBody, TableHeader, TableHeaderColumn, TableRow } from 'material-ui/Table';
import TextField from 'material-ui/TextField';

import Pagination from 'components/Libs/Pagination';

import { searchCargoDuplicates, clearDuplicates } from 'actions/cargoes/duplicates';
import styles from 'styles';
import helpers from 'helpers';

import CargoDuplicatesRow from './Row';

class CargoDuplicatesTable extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            rowsPerPage: [10, 20, 30, 50, 100],
            rows: [],
            numberOfRows: 10,
            page: 1,
            total: undefined,
            cargoDuplicates: [],
        };

        this.handleUpdateRow = this.handleUpdateRow.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
    }

    UNSAFE_componentWillReceiveProps(props) {
        if (props.cargoDuplicates) {
            const arr = [];
            const keys = Object.keys(props.cargoDuplicates);
            let { page } = this.state;

            for (let i = 0; i < keys.length; i++) {
                props.cargoDuplicates[keys[i]].entities.forEach((entity) => {
                    const categoryName = entity.parent ? entity.parent.name : null;

                    arr.push({
                        name: props.cargoDuplicates[keys[i]]._id,
                        id: entity._id,
                        categoryName,
                        details: entity.details,
                        sf: entity.sf,
                        addedByRole: entity.addedByRole,
                        errors: props.cargoDuplicates[keys[i]].errors,
                    });
                });
            }

            if (props.searchText !== this.props.searchText) {
                page = 1;
            }

            this.setState({
                searchText: props.searchText,
                total: arr.length,
                cargoDuplicates: helpers.filterSearch(arr, props.searchText, ['name', 'categoryName']),
                page,
            }, () => {
                this.handleUpdateRow(this.state);
            });
        }
    }

    changeRowsByPagination(state) {
        const elementsOnPage = state.numberOfRows;
        const offset = state.page - 1;
        const from = offset * elementsOnPage;
        const to = (offset * elementsOnPage) + elementsOnPage;

        return this.state.cargoDuplicates.slice(from, to);
    }

    handleUpdateRow(newState) {
        const rows = this.changeRowsByPagination(newState);
        const state = newState;
        state.rows = rows;

        this.setState(state);
    }

    handleSearch(e) {
        this.props.searchCargoDuplicates(e.target.value.toLowerCase());
    }

    componentWillUnmount() {
        this.props.clearDuplicates();
    }

    render() {
        const { rows } = this.state;

        let renderPagination = (<Pagination
            total={this.state.cargoDuplicates.length}
            rowsPerPage={this.state.rowsPerPage}
            page={this.state.page}
            numberOfRows={this.state.numberOfRows}
            updateRows={this.handleUpdateRow}
        />);
        let renderTable = (<Table selectable={false}>
            <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
                <TableRow>
                    <TableHeaderColumn
                        style={styles.tableRowColumnCSS}
                    >Cargo name
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        style={styles.tableRowColumnCSS}
                    >Cargo type
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        style={styles.tableRowColumnCSS}
                    >Details
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        style={styles.tableRowColumnSmallCSS}
                    >Sf
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        style={styles.tableRowColumnSmallCSS}
                    >{null}
                    </TableHeaderColumn>
                </TableRow>
            </TableHeader>

            <TableBody displayRowCheckbox={false}>
                {
                    rows.map(item => <CargoDuplicatesRow key={item.id} item={item} />)
                }
            </TableBody>
        </Table>);

        if (!rows.length) {
            renderTable = (<div className='nothing-found'>Not found</div>);
            renderPagination = null;
        }

        return (
            <div>
                <div className='table-header'>
                    <div className='item'>
                        <TextField
                            defaultValue={this.props.searchText}
                            floatingLabelText='Search'
                            onChange={this.handleSearch}
                        />
                    </div>

                    <div className='item'>
                        {renderPagination}
                    </div>
                </div>

                <div className='table-body'>
                    {renderTable}
                </div>
            </div>
        );
    }
}

export default connect(
    state => ({
        searchText: state.cargoDuplicates.searchText,
        cargoDuplicates: state.cargoDuplicates.items,
    }),
    dispatch => bindActionCreators({
        searchCargoDuplicates,
        clearDuplicates,
    }, dispatch),
)(CargoDuplicatesTable);



// WEBPACK FOOTER //
// ./app/components/Cargoes/Duplicates/Table.jsx